import { useParams, useNavigate } from 'react-router-dom';
import { categories, categoryContent } from '@/mocks/videoData';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const items = categoryContent[slug || 'movie'] || categoryContent.movie;

  const breadcrumbs = [
    { label: '首页', href: '/' },
    { label: currentCategory.name, href: `/category/${currentCategory.slug}` },
  ];

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="webpage"
        pageTitle={`${currentCategory.name} - 蘑菇视频`}
        pageDescription={`蘑菇视频${currentCategory.name}频道，海量${currentCategory.name}资源，高清免费在线观看。涵盖最新热门${currentCategory.name}，每日更新。`}
        pageUrl={`https://mogu.video/category/${currentCategory.slug}`}
        breadcrumbs={breadcrumbs}
      />
      <Navbar />

      <main className="min-h-screen bg-background-50">
        <div className="pt-20 pb-4 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
              {breadcrumbs.map((crumb, i) => (
                <span key={crumb.href} className="flex items-center gap-2">
                  {i > 0 && (
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-xs"></i>
                    </span>
                  )}
                  {i === breadcrumbs.length - 1 ? (
                    <span className="text-foreground-800 font-medium">{crumb.label}</span>
                  ) : (
                    <a
                      href={crumb.href}
                      onClick={(e) => { e.preventDefault(); navigate(crumb.href); }}
                      className="hover:text-primary-500 cursor-pointer transition-colors"
                    >
                      {crumb.label}
                    </a>
                  )}
                </span>
              ))}
            </nav>

            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
              {currentCategory.name}
            </h1>

            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
              {categories.map((cat) => (
                <a
                  key={cat.slug}
                  href={`/category/${cat.slug}`}
                  onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); }}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-200 text-foreground-700 hover:bg-background-300'
                  }`}
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={`${cat.icon} text-sm`}></i>
                  </span>
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <section className="px-4 md:px-6 pb-14">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {items.map((item) => (
                <a
                  key={item.id}
                  href={`/article/${item.slug}`}
                  onClick={(e) => { e.preventDefault(); navigate(`/article/${item.slug}`); }}
                  className="group cursor-pointer"
                >
                  <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3 bg-background-200">
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute top-2 left-2">
                      <span className="inline-block px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded">
                        {item.rating}
                      </span>
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                      <span className="text-white text-xs font-medium flex items-center gap-1">
                        <span className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-play-fill text-sm"></i>
                        </span>
                        立即观看
                      </span>
                    </div>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.year}</p>
                </a>
              ))}
            </div>

            {items.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">暂无内容</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}